import {React, useState, useEffect} from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Table from 'react-bootstrap/Table';
import { Button,Modal,ModalHeader } from 'reactstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Riskclasses() {
    document.title = "Risk classes | MATV Insurance Agency";

    const [riskClasses, setRiskclasses] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [selectedRisk, setSelectedrisk] = useState('')
    const [risk, setRisk] = useState('');
    const [code, setCode] = useState('');
    const [submitText, setSubmittext] = useState('Submit risk class')
    const [updateText, setUpdatetext] = useState('Save changes')
    const [deleteText, setDeletetext] = useState('Remove risk class')



    useEffect(()=>{
        const fetchRiskclasses = async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3061/api/getRiskclasses');
            const data = await res.json();
            setRiskclasses(data)
        }

        fetchRiskclasses();

    },[])

    const fetchRiskclasses = async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3061/api/getRiskclasses');
            const data = await res.json();
            setRiskclasses(data)
        }

    const toggle =()=>{
        setModal(!modal)

    }

    const submitRiskclass =async()=>{
        if(risk !== '' && code !== ''){
            setSubmittext('Please wait...');
            const res = await fetch('https://panel.yunshuglobal.com:3061/api/submitRiskclass',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({risk,code}),
                credentials:"include"

            })

            const data = await res.json();
            const {success} = data;
            if(success == true){
                setSubmittext('Submit risk class')
                toast.success('Risk class added');
                fetchRiskclasses();
                setModal(false)
            }
            else{
                setSubmittext('Submit risk class')
                toast.error('Something went wrong!')
            }

        }
        else{
            toast.error('All fields are required!');
        }
    }

    const toggle2 =async(e)=>{
        const id = e.target.value;
        setSelectedrisk(id)
        const res = await fetch(`https://panel.yunshuglobal.com:3061/api/getThisrisk?id=${id}`);
        const data = await res.json();
        setRisk(data.RiskClass);
        setCode(data.RiskCode)
        setModal2(!modal2)

    }

    const updateRiskclass =async()=>{
        setUpdatetext('Please wait...')
        const res = await fetch('https://panel.yunshuglobal.com:3061/api/updateRiskclass',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({risk,code,selectedRisk}),
            credentials:"include"
        })

        const data = await res.json();
            const {success} = data;
            if(success == true){
                setUpdatetext('Save changes')
                toast.success('Changes saved');
                fetchRiskclasses();
                setModal2(false)
            }
            else{
                setUpdatetext('Save changes')
                toast.error('Something went wrong!')
            }
    }

    const removeRisk =async()=>{
        setDeletetext('Please wait')
        const res = await fetch(`https://panel.yunshuglobal.com:3061/api/deleteRisk?id=${selectedRisk}`);
        const data = await res.json();
        const {success} = data;
        if(success == true){
                setUpdatetext('Remove risk class')
                toast.success('Risk class removed');
                fetchRiskclasses();
                setModal2(false)
            }
            else{
                setUpdatetext('Remove risk class')
                toast.error('Something went wrong!')
            }

    }


  return (
    <div className='pagesContainer'>
                <ToastContainer />
                <Breadcrumbs title="MATV" breadcrumbItem='Risk classes' />
                <div className="card">
                <div className='addButton'>
                    <Button  color='success' onClick={toggle} >+ New Risk Class</Button>
                </div>
                <div className="table-responsive">
                <Table striped bordered hover>

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Class</th>
                            <th scope="col">Code</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {riskClasses.map((val,index)=>{
                        
                            return(
                                <tr>
                                    <td>{index+1}</td>
                                   
                                    <td><button className='tableButton' value={val.id} onClick={toggle2} >{val.RiskClass}</button></td>
                                    <td>{val.RiskCode}</td>
                                   
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
                </div>

        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader>New risk class</ModalHeader>
            <div className="modalContainer">
                <FloatingLabel className='formInputs' controlId="floatingInputGrid" label="Risk class" onChange={(e)=>{setRisk(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={risk}  type="text" placeholder="Risk class" />
                </FloatingLabel>
                <FloatingLabel className='formInputs' controlId="floatingInputGrid" label="Risk code" onChange={(e)=>{setCode(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={code}  type="text" placeholder="Risk code" />
                </FloatingLabel>
                
                <Button color='success' style={{marginTop:'3%'}} onClick={submitRiskclass}>{submitText}</Button>
            </div>
        </Modal>

        <Modal isOpen={modal2} toggle={toggle2}>
            <ModalHeader>Edit risk class</ModalHeader>
            <div className="modalContainer">
                <FloatingLabel className='formInputs' controlId="floatingInputGrid" label="Risk class" onChange={(e)=>{setRisk(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={risk}  type="text" placeholder="Risk class" />
                </FloatingLabel>
                <FloatingLabel className='formInputs' controlId="floatingInputGrid" label="Risk code" onChange={(e)=>{setCode(e.target.value)}}>
                    <Form.Control  className='inputSearch' value={code}  type="text" placeholder="Risk code" />
                </FloatingLabel>
                
                <div className="modalButtons">
                <Button color='success' style={{marginTop:'3%'}} onClick={updateRiskclass}>{updateText}</Button>
                <Button color='danger' style={{marginTop:'3%',marginLeft:"3%"}} onClick={removeRisk}>{deleteText}</Button>

                </div>
               
            </div>
        </Modal>
    </div>
  )
}
